
import { ButtonProps, GroupProps, MantineSize } from '@mantine/core';
import classes from './ConfirmationModal.module.css';
import { modals } from '@mantine/modals';
import { ReactNode } from 'react';
export type ConfirmLabels = Record<'confirm' | 'cancel', ReactNode>;
interface ConfirmModalProps {
  modalId?: string;
  id?: string;
  title?: string;
  children?: React.ReactNode;
  onCancel?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  closeOnConfirm?: boolean;
  closeOnCancel?: boolean;
  cancelProps?: ButtonProps & React.ComponentPropsWithoutRef<'button'>;
  confirmProps?: ButtonProps & React.ComponentPropsWithoutRef<'button'>;
  groupProps?: GroupProps;
  labels?: ConfirmLabels;
  size?: MantineSize
}
export default function ConfirmationModal({
  title = 'Confirmar',
  children,
  onCancel,
  onClose,
  onConfirm,
  labels = { confirm: 'Aceptar', cancel: 'Cancelar' },
  size = 'md',
  closeOnConfirm = true,
  modalId,
  confirmProps,
  cancelProps
}: ConfirmModalProps) {
  
  return modals.openConfirmModal({
    modalId,
    closeOnConfirm,
    title,
    children,
    onCancel,
    onClose,
    onConfirm,
    labels,
    size,
    confirmProps: {
      'data-testid': 'confirmation-modal-confirm',
      ...confirmProps
    },
    cancelProps: {
      'data-testid': 'confirmation-modal-cancel',
      ...cancelProps
    }
  });
}
